<button mat-flat-button class="do3-prenota-button rounded lightBlue">
  <mat-icon>calendar_today</mat-icon>
  {{buttonText}}
</button>
